module.exports = __webpack_public_path__ + "static/media/gr2.bce3a906.PNG";